/**
 * Must stay in sync with HomeServices::EquipmentImageUploadLimits::MAX_BYTES in the API
 * (tudi-admin-api/app/services/home_services/equipment_image_upload_limits.rb).
 */
export const EQUIPMENT_IMAGE_MAX_BYTES = 5 * 1024 * 1024;

export const EQUIPMENT_IMAGE_ACCEPTED_MIME_TYPES = ['image/jpeg', 'image/png'] as const;
